import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Tide } from '../_models/tide';

import { ApiService } from './api.service';

import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class TideService extends ApiService {
  constructor(private http: Http) {
    super('api/tides/', http);
  }

  getTide(id: number): Observable<Tide> {
    return this.http
      .get(`${this.apiUrl + this.endpointUrl}${id}/`, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }

  requestForUpdate(id: number, status: boolean): Observable<Tide> {
    const data = { update_requested: status };
    return this.http
      .put(`${this.apiUrl}api/tides-update-request/${id}/`, data, { headers: this.getHeaders() })
      .map(this.extractData)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/tide.service.ts